module.exports = __webpack_public_path__ + "static/media/document.fb0e9a96.svg";